import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Switch, Route, Redirect } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import Helmet from 'react-helmet';
import history from 'modules/history';
import RoutePublic from 'modules/RoutePublic';
import config from 'config';
import Home from 'routes/Home';
import NotFound from 'routes/NotFound';
import { closeIntro } from 'actions';
import Introduce from 'components/Introduce';

export class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = ({
    });
  }

  static propTypes = {
    app: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  render() {
    const { app, dispatch } = this.props;

    return (
      <ConnectedRouter history={history}>
        <div>
          <Helmet
            defer={false}
            htmlAttributes={{ lang: 'en-us' }}
            encodeSpecialCharacters={true}
            defaultTitle={config.title}
            titleTemplate={`%s | ${config.name}`}
            titleAttributes={{ itemprop: 'name', lang: 'en-us' }}
          />
          <Introduce isopen={app.isfirstvisit} handleCloseClick={() => dispatch(closeIntro(false))} />
          <main className="app__main">
            <Switch>
              <Route exact path="/" render={() => (<Redirect to="/tags/qatar-charity" />)} />
              <RoutePublic path="/node/:nodeid" exact component={Home} dispatch={dispatch} />
              <RoutePublic path="/edge/:edgeid" exact component={Home} dispatch={dispatch} />
              <RoutePublic path="/tags/:tag" exact component={Home} dispatch={dispatch} />
              <RoutePublic path="/country/:country" exact component={Home} dispatch={dispatch} />
              <Route component={NotFound} />
            </Switch>
          </main>
        </div>
      </ConnectedRouter>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    app: state.app,
  };
}

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./scripts/containers/App.jsx